import { render, staticRenderFns } from "./Negatives.vue?vue&type=template&id=34dc8f18&scoped=true&"
import script from "./Negatives.vue?vue&type=script&lang=js&"
export * from "./Negatives.vue?vue&type=script&lang=js&"
import style0 from "./Negatives.vue?vue&type=style&index=0&id=34dc8f18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc8f18",
  null
  
)

export default component.exports